
const quickAccessLinks: { label: string; link: string }[] = [
  { label: 'فروشگاه‌ها', link: '#' },
  { label: 'دسته‌بندی محصولات', link: '#' },
  { label: 'دریافت اعتبار', link: '#' },
  { label: 'فروشنده شوید', link: '/' },
  { label: 'سوالات متداول', link: '#' }
]

const legalLinks: { label: string; link: string }[] = [
  { label: 'قوانین و مقررات', link: '#' },
  { label: 'حریم خصوصی', link: '#' },
  { label: 'شرایط استفاده از اعتبار', link: '#' },
  { label: 'رسیدگی به شکایات', link: '#' }
]

const socialLinks: { label: string; href: string }[] = [
  { label: 'اینستاگرام', href: 'https://instagram.com/apoloan' },
  { label: 'لینکدین', href: 'https://www.linkedin.com/company/apoloan/' }
]

export { legalLinks, quickAccessLinks, socialLinks }
